import HttpService from './httpService';
import config from '../../config';

class AdditioApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async obtenerAlumnoAdditio({ idAdditio }) {
    return this.get('obtenerAlumnoMoodle', { params: { idAdditio } });
  }

  async importarNotasAdditio(data, alumnosIds) {
    return this.post('importarNotasMoodle', data, alumnosIds);
  }

  async importarNotasD2L(data, alumnosIds) {
    return this.post('importarNotasD2L', data, alumnosIds);
  }

  async sacarRAS({ userId, headquarter, group, courseYear, type }) {
    return this.get('sacarRAS', {
      params: { userId, headquarter, group, courseYear, type },
    });
  }

  // headquarter = sede del alumno (empresaId); el backend lo exige para
  // avisar a los profesores del alumno (sin él respondía 500 tras suspender).
  async cambiarEstadoAlumnoMoodle({ id, isActive, headquarter }) {
    return this.post('cambiarEstadoAlumnoMoodle', { id, isActive, headquarter });
  }
}

const additioApiService = new AdditioApiService(config.REACT_APP_NODE_API);
export default additioApiService;
